import { createReducer, on } from '@ngrx/store';
import * as ReportsActions from '../actions/reports.actions';

export const reportsFeatureKey = 'reports';

export interface State {
  currentPage: number,
  totalPage: number,
  reports: any,
  reportsCount: any,
  productSerialNumber: any,
  picked: any,
  pickActivity: any,
  pickActivity_total: number,
  productSerialNumberCount: any,
  pickedCount: any,
  received: any,
  receivedCount: any,
  reorder: any,
  reorderCount: any,
  filterType: string,
  filterID: number
  total: number,
  product_serialnumber_total: number,
  picked_total: number,
  received_total: number,
  reorder_total: number,
  query: string,
  isLoading: boolean,
  sortType: string,
  direction: string,
  report: any,
  selected: any,
  pickedSelected: any,
  productSerialNumberSelected: any,
  receivedSelected: any,
  reorderSelected: any,
  isMasterChecked: boolean,
  barcodes: any[]

  /**
   * Errors
   */
  duplicateBarcode: boolean
}

export const initialState: State = {
  currentPage: 0,
  totalPage: 0,
  reports: null,
  reportsCount: 0,
  productSerialNumber: null,
  picked: null,
  pickActivity: [],
  pickActivity_total: 0,
  productSerialNumberCount: 0,
  pickedCount: 0,
  received: null,
  receivedCount: 0,
  reorder: null,
  reorderCount: 0,
  report: null,
  filterType: null,
  total: 0,
  product_serialnumber_total: 0,
  picked_total: 0,
  received_total: 0,
  reorder_total: 0,
  filterID: 0,
  query: "",
  isLoading: true,
  sortType: null,
  direction: null,
  selected: [],
  productSerialNumberSelected: [],
  pickedSelected: [],
  receivedSelected: [],
  reorderSelected: [],
  isMasterChecked: false,
  barcodes: null,
  duplicateBarcode: false
};

export const reducer = createReducer(
  initialState,

  on(ReportsActions.loadReports, state => state),
  on(ReportsActions.loadReportsSuccess, (state, action) => ({
    ...state,
    reports: [...action.reports],
    reportsCount: action.reports.length,
    total: action.total,
    totalPage : Math.ceil(action.total / 100),
    isLoading: false
  })),
  on(ReportsActions.loadReportsFailure, (state, action) => ({ ...state, isLoading: false })),
  on(ReportsActions.loadPicked, state => state),
  on(ReportsActions.loadPickedSuccess, (state, action) => ({
    ...state,
    picked: [...action.picked],
    pickedCount: action.picked.length,
    picked_total: action.picked_total,
    totalPage : Math.ceil(action.picked_total / 100),
    isLoading: false
  })),
  on(ReportsActions.loadPickedFailure, (state, action) => ({ ...state, isLoading: false })),
  on(ReportsActions.loadPickActivity, state => state),
  on(ReportsActions.loadPickActivitySuccess, (state, action) => ({
    ...state,
    pickActivity: [...action.pickActivity],
    pickActivity_total: action.pickActivity_total,
    totalPage: Math.ceil(action.pickActivity_total / 100),
    isLoading: false
  })),
  on(ReportsActions.loadPickActivityFailure, (state, action) => ({ ...state, isLoading: false })),
  on(ReportsActions.loadProductSerialNumber, state => state),
  on(ReportsActions.loadProductSerialNumberSuccess, (state, action) => ({
    ...state,
    productSerialNumber: [...action.productSerialNumber],
    productSerialNumberCount: action.productSerialNumber.length,
    product_serialnumber_total: action.product_serialnumber_total,
    totalPage : Math.ceil(action.product_serialnumber_total / 100),
    isLoading: false
  })),
  on(ReportsActions.loadProductSerialNumberFailure, (state, action) => ({ ...state, isLoading: false })),
  on(ReportsActions.loadReceived, state => state),
  on(ReportsActions.loadReceivedSuccess, (state, action) => ({
    ...state,
    received: [...action.received],
    receivedCount: action.received.length,
    received_total: action.received_total,
    totalPage : Math.ceil(action.received_total / 100),
    isLoading: false
  })),
  on(ReportsActions.loadReceivedFailure, (state, action) => ({ ...state, isLoading: false })),
  on(ReportsActions.loadReorder, state => state),
  on(ReportsActions.loadReorderSuccess, (state, action) => ({
    ...state,
    reorder: [...action.reorder],
    reorderCount: action.reorder.length,
    reorder_total: action.reorder_total,
    totalPage : Math.ceil(action.reorder_total / 100),
    isLoading: false
  })),
  on(ReportsActions.loadReorderFailure, (state, action) => ({ ...state, isLoading: false })),
  on(ReportsActions.loadReport, state => state),
  on(ReportsActions.loadReportSuccess, (state, action) => ({
    ...state,
    report: action.report,
    isLoading: false
  })),
  on(ReportsActions.loadReportFailure, (state, action) => ({ ...state, isLoading: false })),
  on(ReportsActions.filterByCategory, (state, action )=> ({
    ...state,
    sortType: action.active,
    direction: action.direction,
    isLoading: true
  })),
  on(ReportsActions.filterByCategorySuccess, (state, action) => ({
    ...state,
    reports: action.reports,
    reportsCount: action.reports.length,
    total: action.total,
    totalPage : Math.ceil(action.total / 100),
    isLoading: false
  })),
  on(ReportsActions.filterByCategoryFailure, (state, action) => ({
    ...state,
    error: action.error,
    isLoading: false,
  })),
  on(ReportsActions.filterByReorderCategory, (state, action )=> ({
    ...state,
    sortType: action.active,
    direction: action.direction,
    isLoading: true
  })),
  on(ReportsActions.filterByReorderCategorySuccess, (state, action) => ({
    ...state,
    reorder: action.reorder,
    reorderCount: action.reorder.length,
    reorder_total: action.reorder_total,
    totalPage : Math.ceil(action.reorder_total / 100),
    isLoading: false
  })),
  on(ReportsActions.filterByReorderCategoryFailure, (state, action) => ({
    ...state,
    error: action.error,
    isLoading: false,
  })),
  on(ReportsActions.filterByStorages, (state, action )=> ({
    ...state,
    sortType: action.active,
    direction: action.direction,
    isLoading: true
  })),
  on(ReportsActions.filterByStoragesSuccess, (state, action) => ({
    ...state,
    reports: action.reports,
    reportsCount: state.reports.length,
    total: action.total,
    totalPage : Math.ceil(action.total / 100),
    isLoading: false
  })),
  on(ReportsActions.filterByStoragesFailure, (state, action) => ({
    ...state,
    error: action.error,
    isLoading: false,
  })),
  on(ReportsActions.filterReorderByStorages, (state, action )=> ({
    ...state,
    sortType: action.active,
    direction: action.direction,
    isLoading: true
  })),
  on(ReportsActions.filterReorderByStoragesSuccess, (state, action) => ({
    ...state,
    reorder: action.reorder,
    rreorderCount: state.reorder.length,
    reorder_total: action.reorder_total,
    totalPage : Math.ceil(action.reorder_total / 100),
    isLoading: false
  })),
  on(ReportsActions.filterReorderByStoragesFailure, (state, action) => ({
    ...state,
    error: action.error,
    isLoading: false,
  })),
  on(ReportsActions.search, (state, action) => ({
    ...state,
    query: action.query,
    isLoading: true
  })),
  on(ReportsActions.searchSuccess, (state, action) => ({
    ...state,
    reports: action.reports,
    reportsCount: action.reports.length,
    total: action.total,
    totalPage : Math.ceil(action.total / 100),
    isLoading: false
  })),
  on(ReportsActions.searchFailure, (state, action) => ({
    ...state,
    reports: [],
    reportsCount: 0,
    total: 0,
    error: action.error,
    isLoading: false,
  })),
  on(ReportsActions.searchPicked, (state, action) => ({
    ...state,
    query: action.query,
    isLoading: true
  })),
  on(ReportsActions.searchPickedSuccess, (state, action) => ({
    ...state,
    picked: action.picked,
    pickedCount: action.picked.length,
    picked_total: action.picked_total,
    totalPage : Math.ceil(action.picked_total / 100),
    isLoading: false
  })),
  on(ReportsActions.searchPickedFailure, (state, action) => ({
    ...state,
    picked: [],
    pickedCount: 0,
    picked_total: 0,
    error: action.error,
    isLoading: false,
  })),

  on(ReportsActions.searchProductSerialNumber, (state, action) => ({
    ...state,
    query: action.query,
    isLoading: true
  })),
  on(ReportsActions.searchProductSerialNumberSuccess, (state, action) => ({
    ...state,
    productSerialNumber: action.productSerialNumber,
    productSerialNumberCount: action.productSerialNumber.length,
    product_serialnumber_total: action.product_serialnumber_total,
    totalPage : Math.ceil(action.product_serialnumber_total / 100),
    isLoading: false
  })),
  on(ReportsActions.searchProductSerialNumberFailure, (state, action) => ({
    ...state,
    error: action.error,
    isLoading: false,
  })),

  on(ReportsActions.searchReceived, (state, action) => ({
    ...state,
    query: action.query,
    isLoading: true
  })),
  on(ReportsActions.searchReceivedSuccess, (state, action) => ({
    ...state,
    received: action.received,
    receivedCount: action.received.length,
    received_total: action.received_total,
    totalPage : Math.ceil(action.received_total / 100),
    isLoading: false
  })),
  on(ReportsActions.searchReceivedFailure, (state, action) => ({
    ...state,
    received: [],
    receivedCount: 0,
    received_total: 0,
    error: action.error,
    isLoading: false,
  })),
  on(ReportsActions.searchPicked, (state, action) => ({
    ...state,
    query: action.query,
    isLoading: true
  })),
  on(ReportsActions.searchReorderSuccess, (state, action) => ({
    ...state,
    reorder: action.reorder,
    reorderCount: action.reorder.length,
    reorder_total: action.reorder_total,
    totalPage : Math.ceil(action.reorder_total / 100),
    isLoading: false
  })),
  on(ReportsActions.searchReorderFailure, (state, action) => ({
    ...state,
    reorder: [],
    reorderCount: 0,
    reorder_total: 0,
    error: action.error,
    isLoading: false,
  })),
  on(ReportsActions.incrementPage, (state, action) => ({ 
    ...state,
    currentPage: state.currentPage + 1
  })),
  on(ReportsActions.decrementPage, (state, action) => ({ 
    ...state,
    currentPage: state.currentPage - 1
  })),
  on(ReportsActions.resetPage, (state, action) => ({ 
    ...state,
    currentPage: 0,
    query: ""
  })),
  on(ReportsActions.incrementPage, (state, action) => ({ 
    ...state,
  })),
  on(ReportsActions.incrementPageSuccess, (state, action) => ({ 
    ...state,
    currentPage: action.currentPage
  })),
  on(ReportsActions.setFilterType, (state, action) => ({
    ...state,
    filterType: action.filterType,
    filterID: action.filterID
  })),
  on(ReportsActions.setSelected, (state, action) => ({
    ...state,
    selected: action.selected,
    isMasterChecked: true
  })),
  on(ReportsActions.setPickedSelected, (state, action) => ({
    ...state,
    pickedSelected: action.pickedSelected,
    isMasterChecked: true
  })),
  on(ReportsActions.setReceivedSelected, (state, action) => ({
    ...state,
    receivedSelected: action.receivedSelected,
    isMasterChecked: true
  })),
  on(ReportsActions.setReorderSelected, (state, action) => ({
    ...state,
    reorderSelected: action.reorderSelected,
    isMasterChecked: true
  })),
  on(ReportsActions.setDeselected, (state) => ({
    ...state,
    selected: [],
    isMasterChecked: false
  })),
  on(ReportsActions.setPickedDeselected, (state) => ({
    ...state,
    pickedSelected: [],
    isMasterChecked: false
  })),
  on(ReportsActions.setReceivedDeselected, (state) => ({
    ...state,
    receivedSelected: [],
    isMasterChecked: false
  })),
  on(ReportsActions.setReorderDeselected, (state) => ({
    ...state,
    reorderSelected: [],
    isMasterChecked: false
  })),
  on(ReportsActions.setSort, (state, action) => ({
    ...state,
    sortType: action.sort,
    direction: action.direction
  })),
  on(ReportsActions.resetReport, (state, action) => ({
    ...state,
    report: null
  })),
  on(ReportsActions.resetReports, (state, action) => ({
    ...state,
    reports: [],
    reportsCount: 0,
    isLoading: true
  })),
  on(ReportsActions.resetFilter, (state, action) => ({
    ...state,
    filterType: null,
    filterID: null
  })),
  on(ReportsActions.onOverride, (state, action) => ({
    ...state,
    reports: state.reports.map(item => 
      item.prdID === action.prdID 
        ? { ...item, prdTotalOnHand: action.onHand } 
        : item
    ),
    report: state.report && state.report.prdID === action.prdID 
      ? { 
          ...state.report, 
          prdTotalOnHand: action.onHand,
          isOnHandUpdated: true
        }
      : state.report,
    
  })),
  on(ReportsActions.setIsLoading, (state, action) => ({
    ...state,
    isLoading: action.isLoading
  })),

);
